<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { SearchMode } from '@utils/types';
import { ReserveType } from '@utils/itinerary';

const flightForm = useFlightForm();
const { setReserveType } = useSearchFormStore();
const route = useRoute();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/plane-ticket',
        },
    ],
});

onMounted(() => {
    flightForm.searchMode = SearchMode.Domestic;
    flightForm.handleCapacityTrackCampaign(
        route.query.utm_campaign as string | undefined
    );
    setReserveType(ReserveType.Flight);
});
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط هواپیما', link: '$routePath' },
    ]),
});
</script>

<template>
    <InformationContainer />
</template>
